import type { Distance, Pixel } from "@pdfking/math"

import { DISTANCE } from "#constants"

const cm = DISTANCE.units.cm.magnitude
const mm = DISTANCE.units.mm.magnitude
const px = DISTANCE.units.px.magnitude

export const CM = (n: number): Distance => (n * cm) as Distance
export const MM = (n: number): Distance => (n * mm) as Distance
export const PX = (n: Pixel): Distance => (n * px) as Distance
export const ToPixel = (d: Distance): Pixel => (d / px) as Pixel
